import { Button, Container } from "react-bootstrap";

const PageCallToAction = ({ messageContent, subtitle }) => {
  return (
    <>
      <section className="text-center py-10 py-md-11 py-xl-12 py-xxxl-13">
        <Container className="py-10 py-md-11 py-xl-12 py-xxl-13">
          <h2 className={`h1 ${subtitle ? "mb-4 mb-md-5" : "mb-10 mb-md-11"}`}>
            {messageContent}
          </h2>
          {subtitle && (
            <p className="lead-xl text-dark mb-10 mb-md-11">
              {subtitle}
            </p>
          )}
          <Button href="/plans" size="lg">
            Start Free Trial
          </Button>
        </Container>
      </section>
    </>
  );
};

export default PageCallToAction;
